import React from 'react';

const closeIcon = () => (
    <svg viewBox="0 0 60 30">
        <polygon points="0,30 60,30 30,0 	" />
    </svg>
)

export default closeIcon;